<div
    class="relative grow overflow-y-auto p-4"
    [ngClass]="{'blur-[2px] pointer-events-none [&_*]:select-none': loading$ | async}"
>
    @if (loading$ | async) {
        <div class="absolute flex left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 justify-center items-center z-50">
            <mat-spinner [diameter]="32"></mat-spinner>
        </div>
    }

    <div class="flex justify-between items-center mb-4">
        <h2 class="text-2xl font-semibold">Spremni za generiranje ugovora</h2>
        <button class="valben-button text-lg" (click)="back()">Natrag</button>
    </div>

    <div class="flex flex-wrap gap-2 mb-4">
        @for (application of applications; track application.masterId) {
        <button
            class="valben-button text-base"
            [ngClass]="selectedApplication?.masterId === application.masterId
                ? 'valben-button--selected' : 'valben-button--quiet'"
            (click)="selectApplication(application)"
        >
            {{ application.name }} {{ application.surname }} ({{ application.mbrad }})
        </button>
        }
    </div>

    @if (selectedApplication) {
        @if (viewState === viewStateEnum.Date) {
            <div class="flex flex-col gap-4">
                <valben-date-time-picker
                    key="startDate"
                    [itemObservable]="date$"
                    [update]="updateStartDate"
                    [minDate]="minStartDate"
                    title="Datum početka ugovora"
                    [optional]="false">
                </valben-date-time-picker>
                <valben-date-time-picker
                    key="endDate"
                    [itemObservable]="date$"
                    [update]="updateEndDate"
                    [minDate]="minEndDate"
                    [maxDate]="maxEndDate"
                    title="Datum završetka ugovora"
                    [optional]="false">
                </valben-date-time-picker>

                <div class="flex justify-end">
                    <button class="valben-button" (click)="previewContracts()">Pregledaj ugovore</button>
                </div>
            </div>
        }
        @if (viewState === viewStateEnum.Preview) {
            <div class="flex flex-col gap-4">
                @for (name of contractNames; track $index; let i = $index) {
                <div class="flex flex-col gap-2">
                    <a
                        class="text-lg cursor-pointer underline text-valamarblueprimary hover:text-valamardarkgray"
                        (click)="openPdf(i); $event.preventDefault()">
                        {{ name }}
                    </a>
                    @if (!docxInput[i]) {
                        <button class="valben-button w-fit" (click)="removeContract(i)">
                            Obriši ugovor
                        </button>
                    }
                    @if (docxInput[i]) {
                        <button
                            class="valben-button w-fit"
                            (click)="downloadContract(i)">
                            Preuzmi Word Dokument
                        </button>
                        <valben-file-input
                            key="blob"
                            [itemObservable]="contractInputs$[i]"
                            [update]="contractUpdates[i]"
                            fileType=".docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                            [error]="false"
                            [isKng]="true"
                            [previewFile]="false">
                        </valben-file-input>
                    }
                </div>
                }

                <div class="flex justify-end">
                    <button class="valben-button w-fit" (click)="generateContracts()">Generiraj ugovore</button>
                </div>
            </div>
        }
    }
</div>
